import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import i18n from './i18n';
import '../styles-v2/AboutUsAndSectors.css';
import {
    FaIndustry, FaSeedling, FaStore
} from 'react-icons/fa';

const AboutUsAndSectors = () => {
    const { t } = useTranslation();
    const { lang } = useParams();


    useEffect(() => {
        if (lang && i18n.language !== lang) {
            i18n.changeLanguage(lang).catch(err => console.error("Error sincronizando idioma:", err));
        }
    }, [lang]);

    return (

        <div id="nosotros" className="about-us-sectors-section">
            <div className="flex-container">


                <div className="about-us-left">
                    <div className="content-wrapper">
                        <h2>{t('about.title')}</h2>
                        <p>
                            {t('about.description')}
                        </p>
                    </div>
                </div>

                {/* Sección Derecha - Grilla de Sectores */}
                <div className="sectors-right">
                    <div className="content-wrapper">
                        <h2>{t('about.sectors_title')}</h2>
                        <div className="sectores-grid">

                            {/* Tarjeta Industrial */}
                            <div className="sector-card">
                                <h3 className="flex items-center gap-2 text-xl font-bold">
                                    <FaIndustry className="text-gray-700 shrink-0" />
                                    {t('about.industrial_title')}
                                </h3>
                                <p>
                                    {t('about.industrial_desc')}
                                </p>
                            </div>

                            {/* Tarjeta Comercial */}
                            <div className="sector-card">
                                <h3 className="flex items-center gap-2 text-xl font-bold">
                                    <FaStore className="text-blue-600 shrink-0" />
                                    {t('about.commercial_title')}
                                </h3>
                                <p>
                                    {t('about.commercial_desc')}
                                </p>
                            </div>

                            {/* Tarjeta Agropecuario */}
                            <div className="sector-card">
                                <h3 className="flex items-center gap-2 text-xl font-bold">
                                    <FaSeedling className="text-green-600 shrink-0" />
                                    {t('about.agricultural_title')}
                                </h3>
                                <p>
                                    {t('about.agricultural_desc')}
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUsAndSectors;